module.exports = __webpack_public_path__ + "static/timeline1993-eb818c57cf10a79e7b83153037bfb427.jpeg";